if (!customElements.get("custom-input")) {
  class CustomInput extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector("input, textarea");

      this.input.addEventListener("focus", this.activeInput.bind(this));
      this.input.addEventListener("blur", this.activeInput.bind(this));
      this.input.addEventListener("input", this.activeInput.bind(this));
      this.input.addEventListener("animationstart", (e) => {
        if (e.animationName === "autofill-start") {
          this.classList.add("active");
        }
      });

      setTimeout(() => {
        if (this.input && this.input.value) {
          this.classList.add("active");
        }
      }, 100);

      this.activeInput();
    }

    activeInput() {
      if (
        document.activeElement === this.input ||
        this.input.value.trim() !== ""
      ) {
        this.classList.add("active");
      } else {
        this.classList.remove("active");
      }
    }
  }

  customElements.define("custom-input", CustomInput);
}

window.addEventListener("load", () => {
  document.body.setAttribute("data-load", "true");

  // check if search / cart drawers exist
  const actionButtons = document.querySelectorAll('[data-action="open"]');
  actionButtons.forEach((item) => {
    const object = item.dataset.object;

    if (object === "cart") {
      const cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer) {
        item.setAttribute("href", window.routes.cart_url);
        item.removeAttribute("data-action");
        item.removeAttribute("data-object");
      }
    } else if (object === "search") {
      const searchDrawer = document.querySelector("search-drawer");
      if (!searchDrawer) {
        item.setAttribute("href", window.routes.search_url);
        item.removeAttribute("data-action");
        item.removeAttribute("data-object");
      }
    }
  });

  // custom button click event
  const customButtons = document.querySelectorAll(".custom-button");
  customButtons.forEach((button) => {
      button.addEventListener("click", function (event) {
        buttonRipple(event, button);
      });
  });
});

if(!customElements.get('parallax-hover-element')){
  class ParallaxHoverElement extends HTMLElement {
    constructor(){
      super();

      this.section = this.closest('.shopify-section') || null;
    }

    connectedCallback(){
      if(this.section){
        this.section.addEventListener('mousemove', (e) => {
          this.imageParallaxEffect(e);
        });
      }
    }

    imageParallaxEffect(e){
      const rect = this.section.getBoundingClientRect();
      const xPos = e.clientX - rect.left;
      const yPos = e.clientY - rect.top;

      const movementStrength = this.dataset.movementStrength || 25;

      // const amountMovedX = (xPos - rect.width / 2) * -0.03; // small movement
      // const amountMovedY = (yPos - rect.height / 2) * -0.03;
      const amountMovedX = (xPos - rect.width / 2) * -movementStrength * 0.01;
      const amountMovedY = (yPos - rect.height / 2) * -movementStrength * 0.01;


      const targets = this.querySelectorAll('img, svg');

      targets.forEach((img) => {
        img.style.transform = `translate(${amountMovedX}px, ${amountMovedY}px)`;
      });
    }
  }
  customElements.define('parallax-hover-element', ParallaxHoverElement);
}

const buttonRipple = (event, button) => {
  const ripple = document.createElement("span");
    ripple.classList.add("ripple");

    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height); // make ripple big enough
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    button.appendChild(ripple);

    ripple.addEventListener("animationend", () => {
    ripple.remove();
  });
}

const debounce = (fn, delay) => {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);
  };
};

document.addEventListener("DOMContentLoaded", onVisibilityChange);
window.addEventListener("load", onVisibilityChange);
window.addEventListener("scroll", throttle(onVisibilityChange, 50), { passive: true });
window.addEventListener("resize", debounce(onVisibilityChange, 100));

// Snackberries (Ladezeit, 29.09.2026): Frueher wurde hier bei jedem Scrollen
// jeder Animationsbereich mit getBoundingClientRect vermessen, abwechselnd mit
// classList.add - das hat jedes Mal ein neues Layout erzwungen. Jetzt meldet ein
// IntersectionObserver, wann ein Bereich die 90-%-Linie des Fensters erreicht
// (gleiche Schwelle wie vorher). onVisibilityChange misst nichts mehr: Es meldet
// nur neue Bereiche an und blendet nachgeladene Elemente in bereits sichtbaren
// Bereichen ein.
const animationObserver = "IntersectionObserver" in window
  ? new IntersectionObserver((entries) => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      entries.forEach((entry) => {
        const rect = entry.boundingClientRect;
        if (entry.isIntersecting || rect.top <= vh * 0.9 || rect.bottom <= vh) {
          animationObserver.unobserve(entry.target);
          entry.target.setAttribute("data-animation-revealed", "");
          revealAnimationElements(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -10% 0px" })
  : null;

function revealAnimationElements(item) {
  item.querySelectorAll(".animation-element:not(.in-view)").forEach((el) => {
    el.classList.add("in-view");
  });
}

function onVisibilityChange() {
  if (!animationObserver) {
    document.querySelectorAll(".animation-wrapper").forEach((item) => {
      if (isPartialElementInViewport(item)) revealAnimationElements(item);
    });
    return;
  }

  document.querySelectorAll(".animation-wrapper:not([data-animation-observed])").forEach((item) => {
    item.setAttribute("data-animation-observed", "");
    animationObserver.observe(item);
  });
  document.querySelectorAll("[data-animation-revealed]").forEach(revealAnimationElements);
}

function isPartialElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  var vh = window.innerHeight || document.documentElement.clientHeight;

  return rect.top <= vh * 0.9 || rect.bottom <= vh;
}

function throttle(fn, limit) {
  var waiting = false;
  return function () {
    if (!waiting) {
      fn();
      waiting = true;
      setTimeout(function () { waiting = false; }, limit);
    }
  };
}

if (!customElements.get("compare-product")){
  class CompareProduct extends HTMLElement {
    constructor(){
      super();
    }

    connectedCallback(){
      this.productId = this.dataset.productId;
      this.productUrl = this.dataset.productUrl;

      const checkbox = this.querySelector('input[type="checkbox"]');
      checkbox.addEventListener('change', this.onChange.bind(this));
      const label = this.querySelector('label');
      label.addEventListener('keydown', (e) => {
        if(e.key === 'Enter'){
          checkbox.checked = !checkbox.checked;
          this.onChange({ target: checkbox });
        }
      });

      this.checkIfSelected();

      this.onHideCompareCheckboxUnsubscriber = PubSub.subscribe(
        PubSub.events.hideCompareProductCheckbox, this.handleHideCompareCheckbox.bind(this)
      );

      this.onUncheckCompareCheckboxUnsubscriber = PubSub.subscribe(
        PubSub.events.uncheckCompareProductCheckbox, this.handleUncheckCompareCheckbox.bind(this)
      );

      this.onUncheckAllCompareProductCheckboxesUnsubscriber = PubSub.subscribe(
        PubSub.events.uncheckAllCompareProductCheckboxes, this.handleUncheckAllCompareProductCheckboxes.bind(this)
      );

      this.onAddToCompareProductUnsubscriber = PubSub.subscribe(
        PubSub.events.updateCheckbox, this.handleDuplicateCheckboxes.bind(this)
      );

      this.checkIfReachedMaxProducts();
    }

    disconnectedCallback(){
      const checkbox = this.querySelector('input[type="checkbox"]');
      checkbox.removeEventListener('change', this.onChange.bind(this));

      this.onHideCompareCheckboxUnsubscriber();
      this.onUncheckCompareCheckboxUnsubscriber();
    }

    handleDuplicateCheckboxes() {
      const compareProducts = JSON.parse(getCookie('compare-products')) || JSON.parse(sessionStorage.getItem('compare-products')) || [];

      let existInCompare = false;
      compareProducts.filter(url => {
        if(url === this.productUrl) {
          existInCompare = true;
        }
      });

      const checkbox = this.querySelector('input[type="checkbox"]');
      if(!existInCompare){
        this.setAttribute('data-hidden', 'true');
        this.setAttribute('inert', '');
        this.setAttribute('data-updating', 'true');
        checkbox.checked = false;
      } else {
        this.setAttribute('data-hidden', 'false');
        this.removeAttribute('inert');
        this.setAttribute('data-updating', 'true');
        checkbox.checked = true;
      }

      this.setAttribute('data-updating', 'false');
    }

    handleHideCompareCheckbox({ checkboxData: { display } }) {
      const compareProducts = JSON.parse(getCookie('compare-products')) || JSON.parse(sessionStorage.getItem('compare-products')) || [];

      let existInCompare = false;
      compareProducts.filter(url => {
        if(url === this.productUrl) {
          existInCompare = true;
        }
      });

      if(display === false && !existInCompare){
        this.setAttribute('data-hidden', 'true');
        this.setAttribute('inert', '');
      } else {
        this.setAttribute('data-hidden', 'false');
        this.removeAttribute('inert');
      }
    }

    handleUncheckCompareCheckbox({ checkboxData: { productUrl } }) {
      this.handleHideCompareCheckbox({ checkboxData: { display: true } });

      if(productUrl !== this.productUrl) return;

      const compareProducts = JSON.parse(getCookie('compare-products')) || JSON.parse(sessionStorage.getItem('compare-products')) || [];

      let existInCompare = false;
      compareProducts.filter(url => {
        if(url === this.productUrl) {
          existInCompare = true;
        }
      });

      // if not exist in compare and display is false, uncheck the box
      if(!existInCompare){
        const checkbox = this.querySelector('input[type="checkbox"]');
        checkbox.checked = false;
      }
    }

    handleUncheckAllCompareProductCheckboxes() {
      this.handleHideCompareCheckbox({ checkboxData: { display: true } });

      const checkbox = this.querySelector('input[type="checkbox"]');
      checkbox.checked = false;
    }

    checkIfSelected(){
      const compareProducts = JSON.parse(getCookie('compare-products')) || JSON.parse(sessionStorage.getItem('compare-products')) || [];

      let existInCompare = false;
      compareProducts.filter(url => {
        if(url === this.productUrl){
          existInCompare = true;
        }
      });

      if(existInCompare){
        const checkbox = this.querySelector('input[type="checkbox"]');
        checkbox.checked = true;
      }
    }

    onChange(e){
      const checkbox = e.target;
      if(!checkbox) return;

      const checked = checkbox.checked;
      if(checkbox.getAttribute('data-updating') === null){
        if(checked){
          this.addToCompare();
        }else{
          this.removeFromCompare();
        }
      }
    }

    addToCompare(){
      const data = {
        productUrl: this.dataset.productUrl
      }
      PubSub.publish(PubSub.events.addToCompareProduct, {
        data
      });

      // update checkbox
      PubSub.publish(PubSub.events.updateCheckbox, {});

      this.checkIfReachedMaxProducts();
    }

    removeFromCompare(){
      const data = {
        productUrl: this.dataset.productUrl
      }

      PubSub.publish(PubSub.events.removeFromCompareProduct, {
        data
      });

      // update checkbox
      PubSub.publish(PubSub.events.updateCheckbox, {});

      this.checkIfReachedMaxProducts();
    }

    checkIfReachedMaxProducts(){
      // if maximum products reached, hide the box
      const compareProducts = JSON.parse(getCookie('compare-products')) || JSON.parse(sessionStorage.getItem('compare-products')) || [];
      const maxProducts = parseInt(sessionStorage.getItem('compare-products-max-product')) || 4;
      if(compareProducts.length >= maxProducts){
        const checkboxData = {
          display: false
        }
        PubSub.publish(PubSub.events.hideCompareProductCheckbox, { checkboxData });
      }else{
        const checkboxData = {
          display: true
        }
        PubSub.publish(PubSub.events.hideCompareProductCheckbox, { checkboxData });
      }
    }
  }

  customElements.define("compare-product", CompareProduct)
}

if( !customElements.get("hover-zoom-image")){
  class HoverZoomImage extends HTMLElement {
    constructor(){
      super();
    }

    connectedCallback(){
      this.image = this.querySelector('img');
      this.wrapper = this.closest('.hover-zoom-image-wrapper') || this;
      this.linkTo = this.dataset.linkTo;

      if(this.linkTo){
        this.wrapper.addEventListener('click', () => {
          window.location.href = this.linkTo;
        });
        this.wrapper.addEventListener('keypress', (e) => {
          if(e.key === 'Enter'){
            window.location.href = this.linkTo;
          }
        });
      }

      this.initializeHoverZoom();
    }

    initializeHoverZoom(){
      if(!this.image) return;

      const radius = 1;

      let raf = null;
      // constants
      const MAX_ZOOM = 1.1;    // scale at center
      const MIN_ZOOM = 1.0;     // scale at or beyond radius

      const onMove = (e) => {
        if(raf) return;

        raf = requestAnimationFrame(() => {
          raf = null;

          const rect = this.image.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          const nx = x / rect.width;
          const ny = y / rect.height;

          const dx = nx - 0.5;
          const dy = ny - 0.5;
          const dist = Math.hypot(dx, dy);

          // Map dist→zoom:
          // t = 0 at center, 1 at radius (or more). Clamp to [0,1].
          const t = Math.min(1, Math.max(0, dist / radius));

          // Linear interpolation from MAX_ZOOM (at center) to MIN_ZOOM (at/beyond radius)
          const zoom = MAX_ZOOM - (MAX_ZOOM - MIN_ZOOM) * t;

          // Apply
          this.image.style.transform = `scale(${zoom})`;

          if (dist < radius) {
            this.image.classList.add('isZoomed');
          } else {
            this.image.classList.remove('isZoomed');
          }
        });
      }

      const onLeave = () => {
        this.image.classList.remove('isZoomed');
      }

      this.wrapper.addEventListener('mouseleave', onLeave);
      this.wrapper.addEventListener("mousemove", onMove);
    }
  }

  customElements.define("hover-zoom-image", HoverZoomImage);
}

/**
 * Focus Trap Utility
 * Traps keyboard focus within a container and makes background content inert.
 */
const FocusTrap = {
  _activeTraps: [],

  /**
   * Get all siblings of the element that should be made inert
   */
  _getBackgroundElements(container){
    const elements = [];
    let el = container;

    while(el && el !== document.body){
      const parent = el.parentElement;
      if(parent){
        Array.from(parent.children).forEach(sibling => {
          if(sibling !== el && !sibling.hasAttribute('inert') && sibling.tagName !== 'SCRIPT' && sibling.tagName !== 'STYLE' && sibling.tagName !== 'LINK'){
            elements.push(sibling);
          }
        });
      }
      el = parent;
    }

    return elements;
  },

  /**
   * Get all focusable elements within a container
   */
  _getFocusableElements(container){
    const selector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]):not([inert])';
    return Array.from(container.querySelectorAll(selector)).filter(el => {
      return !el.closest('[inert]') && !el.closest('[aria-hidden="true"]') && el.offsetParent !== null;
    });
  },

  /**
   * Activate focus trap on a container
   */
  activate(container){
    const bgElements = this._getBackgroundElements(container);
    const trapData = { container, bgElements, handler: null };

    // Make background content inert
    bgElements.forEach(el => {
      el.setAttribute('inert', '');
      el.setAttribute('data-focus-trap-inert', '');
    });

    // Handle Tab key to cycle focus within the container
    trapData.handler = (e) => {
      if(e.key !== 'Tab') return;

      const focusable = this._getFocusableElements(container);
      if(focusable.length === 0){
        e.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if(e.shiftKey){
        if(document.activeElement === first || !container.contains(document.activeElement)){
          e.preventDefault();
          last.focus();
        }
      }else{
        if(document.activeElement === last || !container.contains(document.activeElement)){
          e.preventDefault();
          first.focus();
        }
      }
    };

    container.addEventListener('keydown', trapData.handler);
    this._activeTraps.push(trapData);
  },

  /**
   * Deactivate focus trap on a container
   */
  deactivate(container){
    const trapIndex = this._activeTraps.findIndex(t => t.container === container);
    if(trapIndex === -1) return;

    const trapData = this._activeTraps[trapIndex];

    // Remove inert from background elements
    trapData.bgElements.forEach(el => {
      if(el.hasAttribute('data-focus-trap-inert')){
        el.removeAttribute('inert');
        el.removeAttribute('data-focus-trap-inert');
      }
    });

    // Remove keydown handler
    container.removeEventListener('keydown', trapData.handler);
    this._activeTraps.splice(trapIndex, 1);
  }
};
